<template>
    <div>
        <el-row>
            <el-table
                class="el-table__dark-expandable"
                :data="timelineData"
                v-loading="loading"
                style="width: 100%"
                border
            >
                <el-table-column
                    min-width="100"
                    sortable
                    :label="$t('table.column.userName')"
                    prop="Username"
                />
                <el-table-column
                    min-width="150"
                    sortable
                    :label="$t('table.column.currentStatus')"
                    prop="CurrentStatus"
                />
                <el-table-column
                    min-width="80"
                    sortable
                    :label="$t('table.column.action')"
                    prop="ActionDescription"
                />
                <el-table-column
                    min-width="100"
                    sortable
                    :label="$t('table.column.dateTimeStamp')"
                    :sort-method="(a, b) => sortByDate(a, b, 'DateTimestamp')"
                    prop="DateTimestamp"
                >
                    <template slot-scope="{ row }">
                        {{ formatDate(row.DateTimestamp) }}
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
import InteractWithSort from '../../mixins/interact-with-sort'
import { DateTime } from 'luxon'

export default {
    name: 'timeline',

    props: {
        timelineId: {
            type: String,
            required: true,
        },
        timelineType: {
            type: String,
            required: true,
        },
    },

    mixins: [InteractWithSort],

    data() {
        return {
            timelineData: [],
        }
    },

    created() {
        this.timelineData = []
        let url
        switch (this.timelineType) {
            case 'ACTOR':
                url = `/Actor/${this.timelineId}/Timeline`
                break
            case 'BLC_NOTIFICATION':
                url = `/BLCNotification/${this.timelineId}/Timeline`
                break
            case 'BLC_ROUTE':
                url = `/BLCRoute/${this.timelineId}/Timeline`
                break
            case 'WA_NOTIFICATION':
                url = `/WANotification/${this.timelineId}/Timeline`
                break
            case 'PACKAGE_GROUP':
                url = `/PackageGroup/${this.timelineId}/Timeline`
                break
            case 'PACKAGE_ITEM':
                url = `/PackageItem/${this.timelineId}/Timeline`
                break
            case 'USER':
                url = `/User/${this.timelineId}/Timeline`
                break
            default:
                break
        }

        if (url) {
            this.fetchTimeLineData(url)
        }
    },

    methods: {
        async fetchTimeLineData(url) {
            this.loading = true
            const { data } = await this.$http.get(url)
            this.timelineData = data
            this.loading = false
        },

        formatDate(date) {
            return DateTime.fromISO(date).toLocaleString(
                DateTime.DATETIME_SHORT
            )
        },
    },
}
</script>